export const getDiagnosisTypeErrorKey = (error: any): string | undefined => {
  const data = error?.response?.data || error?.data
  const message = data?.message

  if (Array.isArray(message)) return message[0]
  return typeof message === 'string' ? message : undefined
}
